<template>
    <div class="lds-widget" :style="showcaseColors">
        <h3 class="lds-widget__title">
            {{ widgetTitle }}
        </h3>
        <p class="lds-widget__text">
            {{ widgetSubtitle }}
        </p>
        <div
            class="lds-widget__list"
            :class="gridClass"
        >
            <showcase-offers-item
                v-for="offer in offers"
                :key="offer.id"
                :usp-placement="uspPlacement"
                :text-btn="textBtn"
                :desktop-placement="desktopPlacement"
                :mobile-placement="mobilePlacement"
                :offer="offer"
            />
        </div>
    </div>
</template>

<script setup>
import { toRef } from 'vue';
import ShowcaseOffersItem from './ShowcaseOffersItem.vue';
import commonProps from '../common/сommonProps.js';
import useThemes from './composables/useThemes.js';

const props = defineProps({
    gridClass: {
        type: Object,
        default: () => {},
    },

    settings: {
        type: Object,
        default: () => {},
    },

    offers: {
        type: Array,
        required: true,
    },

    widgetTitle: {
        type: String,
        default: '',
    },

    widgetSubtitle: {
        type: String,
        default: '',
    },

    ...commonProps(),
});
const settings = toRef(props, 'settings');
const { showcaseColors } = useThemes({ settings });
</script>

<style lang="scss" scoped>
.lds-widget {
    container-type: inline-size;
    container-name: lds-widget;

    font-weight: 500 !important;

    * {
        box-sizing: border-box !important;
        font-family: var(--lw-font-family), 'Arial', sans-serif !important;
        outline: none !important;
    }

    &__title {
        margin: 0 0 15px 0 !important;

        font-size: 32px !important;
        font-weight: 600 !important;
        text-align: center;
        color: var(--lw-title) !important;
    }

    &__text {
        margin-bottom: 20px !important;

        font-size: 14px !important;
        line-height: 22px;
        font-weight: 500 !important;
        text-align: center;
        white-space: pre-line;
        color: var(--lw-text) !important;
    }

    &__list {
        display: grid;
        grid-gap: 20px;
        gap: 20px;
        align-items: end;
        margin-top: 16px !important;
        grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
    }

    @container lds-widget (width > 320px) and (width < 702px)  {
        &__list_two-columns-xs {
            grid-template-columns: 1fr 1fr;
            grid-gap: 20px 7px;
            gap: 20px 7px;
        }
    }


    @container lds-widget (width > 702px) {
        &__list {
            grid-gap: 16px;
            gap: 16px;
        }
    }

    @container lds-widget (width > 960px) {
        &__list {
            grid-gap: 20px 24px;
            gap: 20px 24px;

            &_row {
                grid-template-columns: 1fr;
            }
        }

        &__text {
            max-width: 650px;
            margin-left: auto !important;
            margin-right: auto !important;
        }
    }
}
</style>